import { Box, Stack } from '@mui/material';
import { useNavigate } from 'react-router';
import CNLoading from 'src/components/loading-cn/CNLoading';
import TableRox from 'src/components/table-rox/TableRox';
import { paths } from 'src/routes/paths';
import { useCollectiblesStore } from 'src/store/collectibles/collectibles.store';

type Props = {
  onSelectAllRows: any;
  onSelectRow: any;
};

export default function CollectionsTab({ onSelectAllRows, onSelectRow }: Props) {
  const navigate = useNavigate();

  const TABLEHEADER = [
    { id: 'name', label: 'Nome' },
    { id: 'startDate', label: 'Data de Início', type: 'date' },
    { id: 'endDate', label: 'Data de Fim', type: 'date' },
    { id: 'status', label: 'Status', type: 'label' },
  ];

  const [isLoadingCollectionsList, collectionsList] = useCollectiblesStore((store) => [
    store.isLoadingCollectionsList,
    store.collectionsList,
  ]);

  return (
    <Stack spacing={1}>
      {isLoadingCollectionsList ? (
        <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
          <CNLoading />
        </Box>
      ) : (
        <TableRox
          data={collectionsList}
          header={TABLEHEADER}
          defaultOrderBy="name"
          hasSearch
          onClickKey="_id"
          avatarType="default"
          avatarKey="image"
          selectKey="_id"
          selectType="all"
          onClickFunction={(id) => navigate(paths.dashboard.collectionsDetails(id))}
          onSelectAllRowFunction={onSelectAllRows}
          onSelectRowFunction={onSelectRow}
        />
      )}
    </Stack>
  );
}
